import { render, staticRenderFns } from "./folderForm.vue?vue&type=template&id=df904676&scoped=true"
import script from "./folderForm.vue?vue&type=script&lang=js"
export * from "./folderForm.vue?vue&type=script&lang=js"
import style0 from "./folderForm.vue?vue&type=style&index=0&id=df904676&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df904676",
  null
  
)

export default component.exports